// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"style_tableWrapper__Q1HVo","tableComponent":"style_tableComponent__XG7qI"};